<template>
	<div style="width:100%;height:100%;">
		<div id="bartwoMain" ref="bartwo" style="width:100%; height:100%;}"></div>
	</div>
</template>

<script>
let echarts = require('echarts/dist/echarts.simple.min');
var chart = null;
//vuex
import {mapState} from 'vuex'
export default {
  name: 'BarTwoChart',
  props:['oneTitle','twoTitle','titleList','oneBarData','twoBarData'],
  computed:mapState({
		currentIndex:state => state.home.currentIndex
	}),
   watch:{
   		currentIndex(val){
	  		if(val.indexOf('alarmdetail') != -1){
	  			chart.resize()
	  			this.initChart()
	  		}
	  	},
	  	oneBarData: function (val) {
	      this.refresh();
	   	},
	   	twoBarData: function (val) {
	      this.refresh();
	    },
	    titleList: function (val) {
	      this.refresh();
	    }
   },
  mounted(){
  	this.initChart()
  },
  methods:{
  	initChart(){
  		chart = echarts.init(this.$refs.bartwo);
	  	chart.setOption({
			tooltip : {
		        trigger: 'axis',
		        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
		            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
		        }
		    },
	   		grid: {
		        left: '3%',
		        right: '4%',
		        bottom: '3%',
		        containLabel: true
	   		},
	   		xAxis : [
		        {
		            type : 'category',
		            data : this.titleList
		        }
		    ],
		    yAxis : [
		        {
		        	show : false,
		            type : 'value'
		        }
		    ],
			series: [
		        {
		            name:this.oneTitle,
		            type:'bar',
		            label: {
		                normal: {
		                    show: true,
		                    position: 'top'
		                }
		            },
		            itemStyle:{
			                normal:{
			                    color:'#DE3738'
			                }
		            },
		            data:this.oneBarData
		        },
		        {
		            name:this.twoTitle,
		            type:'bar',
		            label: {
		                normal: {
		                    show: true,
		                    position: 'top'
		                }
		            },
		            itemStyle:{
			                 normal:{
			                    color:'#57B83A'
			                }
		            },
		            data:this.twoBarData
		        }
		    ]
		})
  		$(window).resize(chart.resize);
  	},
  	refresh(){
  		chart.setOption({
			tooltip : {
		        trigger: 'axis',
		        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
		            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
		        }
		    },
	   		grid: {
		        left: '3%',
		        right: '4%',
		        bottom: '3%',
		        containLabel: true
	   		},
	   		xAxis : [
		        {
		            type : 'category',
		            data : this.titleList
		        }
		    ],
		    yAxis : [
		        {
		        	show : false,
		            type : 'value'
		        }
		    ],
			series: [
		        {
		            name:this.oneTitle,
		            type:'bar',
		            label: {
		                normal: {
		                    show: true,
		                    position: 'top'
		                }
		            },
		            itemStyle:{
		                normal:{
		                    color:'#DE3738'
		                }
		            },
		            data:this.oneBarData
		        },
		        {
		            name:this.twoTitle,
		            type:'bar',
		            label: {
		                normal: {
		                    show: true,
		                    position: 'top'
		                }
		            },
		            itemStyle:{
		                 normal:{
		                    color:'#57B83A'
		                }
		            },
		            data:this.twoBarData
		        }
		    ]
		})
  	}
  }
}
</script>


// WEBPACK FOOTER //
// BarTwoChart.vue?608e2c1a